import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CTAFinal() {
  const { t } = useTranslation('soumission');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15);

  return (
    <section id="cta-final" className="bg-copper py-16 md:py-20">
      <div
        ref={ref}
        className={`max-w-2xl mx-auto px-4 md:px-6 lg:px-10 text-center transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        <h2 className="font-manrope font-bold text-white text-2xl md:text-3xl lg:text-4xl mb-3">
          {t('cta_h2')}
        </h2>
        <p className="text-white/80 text-base md:text-lg mb-8">
          {t('cta_subtitle')}
        </p>

        <a
          href="tel:+14184769950"
          aria-label="Appeler Couvreur-Lévis.com au 418-476-9950"
          title="Cliquez pour appeler"
          className="inline-flex items-center gap-3 bg-white hover:bg-soft-gray text-slate-primary font-bold px-8 py-4 rounded-md text-lg transition-all duration-300 whitespace-nowrap mb-4"
        >
          <span className="w-10 h-10 flex items-center justify-center rounded-full bg-copper/10">
            <i className="ri-phone-line text-copper" />
          </span>
          {t('cta_phone')}
        </a>

        <p className="text-white/60 text-sm">
          {t('cta_hours')}
        </p>
      </div>
    </section>
  );
}